<form class="searchForm" data-ctx="search-form">
  <button type="submit" class="searchButton" icon-button (click)="onChange()">
    <gl-icon [name]="'search'"></gl-icon>
  </button>
  <input
    type="search"
    class="searchInput"
    [placeholder]="placeholder"
    name="search"
    [(ngModel)]="searchString"
    (ngModelChange)="onChange()"
    autocomplete="new-password"
  />
</form>
